/**
 * Shared bureau logo assets — local SVG first, CDN fallback.
 */
export const BUREAU_LOGO_URLS = {
  equifax: '/assets/provider-logos/equifax.svg',
  experian: '/assets/provider-logos/experian.svg',
  transunion: '/assets/provider-logos/transunion.svg',
};

export const BUREAU_LOGO_FALLBACK_URLS = {
  equifax: 'https://customer-assets.emergentagent.com/job_elite-repair-1/artifacts/qip7anas_Equifax_Logo.svg.png',
  experian: 'https://customer-assets.emergentagent.com/job_elite-repair-1/artifacts/fxv69a4c_Experian_logo.svg.png',
  transunion: 'https://customer-assets.emergentagent.com/job_elite-repair-1/artifacts/ndbajkqy_TransUnion_logo.svg.png',
};

export const BUREAU_DISPLAY_NAMES = {
  equifax: 'Equifax',
  experian: 'Experian',
  transunion: 'TransUnion',
};

/** Normalize bureau name / key to equifax | experian | transunion */
export function normalizeBureauKey(bureau) {
  if (!bureau) return '';
  const compact = String(bureau).toLowerCase().replace(/[^a-z]/g, '');
  if (compact.includes('transunion') || compact === 'tu') return 'transunion';
  if (compact.includes('experian') || compact === 'exp') return 'experian';
  if (compact.includes('equifax') || compact === 'efx') return 'equifax';
  if (BUREAU_LOGO_URLS[compact]) return compact;
  return compact;
}

export function getBureauLogoUrl(bureau, { preferFallback = false } = {}) {
  const key = normalizeBureauKey(bureau);
  if (preferFallback) {
    return BUREAU_LOGO_FALLBACK_URLS[key] || null;
  }
  return BUREAU_LOGO_URLS[key] || BUREAU_LOGO_FALLBACK_URLS[key] || null;
}

export function getBureauDisplayName(bureau) {
  const key = normalizeBureauKey(bureau);
  return BUREAU_DISPLAY_NAMES[key] || bureau || 'Bureau';
}
